/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 205);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_favorite_products__ = __webpack_require__(22);



var SAVE_FAVES_BUTTON_SELECTOR = "#saveFaves";

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_1__modules_favorite_products__["a" /* FAV_BUTTON_SELECTOR */]).on("click", function (e) {
        var $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        var $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_1__modules_favorite_products__["b" /* MODAL_SELECTOR */]);
        var codes = $modal.data("codes") || "";
        var code = $button.data("code");

        if ($button.hasClass(__WEBPACK_IMPORTED_MODULE_1__modules_favorite_products__["c" /* ACTIVE_CLASS */])) {
            __WEBPACK_IMPORTED_MODULE_1__modules_favorite_products__["d" /* sendUnfillToScreenReader */]($button);
            codes = codes.replace(code + ",", "");
        } else {
            __WEBPACK_IMPORTED_MODULE_1__modules_favorite_products__["e" /* sendFillToScreenReader */]($button);
            codes += code + ",";
        }

        $button.toggleClass(__WEBPACK_IMPORTED_MODULE_1__modules_favorite_products__["c" /* ACTIVE_CLASS */]);
        $modal.data("codes", codes);

        e.stopPropagation();
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SAVE_FAVES_BUTTON_SELECTOR).on("click", function () {
        if (window.rcProps.isGuest) {
            __WEBPACK_IMPORTED_MODULE_1__modules_favorite_products__["f" /* openModal */]();
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/favorite-products/favorite/batch", __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
                codes: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_1__modules_favorite_products__["b" /* MODAL_SELECTOR */]).data("codes") || ""
            }), function () {
                window.location.reload();
            });
        }
    });
});

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTIVE_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FAV_BUTTON_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MODAL_SELECTOR; });
/* harmony export (immutable) */ __webpack_exports__["g"] = initFavorites;
/* harmony export (immutable) */ __webpack_exports__["e"] = sendFillToScreenReader;
/* harmony export (immutable) */ __webpack_exports__["d"] = sendUnfillToScreenReader;
/* harmony export (immutable) */ __webpack_exports__["f"] = openModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


var ACTIVE_CLASS = "js-heart-active";
var FAV_BUTTON_SELECTOR = ".js-heart-button";
var MODAL_SELECTOR = "#heart-feature-sync";

var PRODUCT_CODE_TOKEN = "{productCode}";
var FAVORITE_AJAX_URL = "/favorite-products/favorite/" + PRODUCT_CODE_TOKEN;
var UNFAVORITE_AJAX_URL = "/favorite-products/unfavorite/" + PRODUCT_CODE_TOKEN;

var OUTLINE_SELECTOR = ".icon--heart-emoji-outline";
var FILL_SELECTOR = ".icon--heart-emoji-fill";
var ANIMATION_CLASS = "heartbeat";

var NOTIFICATION_SELECTOR = ".js-favorite-notify";
var SCREEN_READER_SELECTOR = ".u-screen-reader";
var FAVORITES_COUNT_SELECTOR = "#my_favorites_count";

var FAVORITE_NOTIFICATION = "favorite-notification";
var UNFAVORITE_NOTIFICATION = "unfavorite-notification";
var FAVORITE_MESSAGE = "favorite-message";
var UNFAVORITE_MESSAGE = "unfavorite-message";

function onFavoritesPage() {
    return window.location.pathname && window.location.pathname.startsWith("/my-favorites");
}

function resetFavoritedButton($heartOutline, $heartFill) {
    $heartOutline.removeClass('u-hide');
    $heartFill.addClass('u-hide').removeClass(ANIMATION_CLASS);
}

function favoriteProduct($button, productCode) {
    var $heartOutline = $button.find(OUTLINE_SELECTOR);
    var $heartFill = $button.find(FILL_SELECTOR);

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(FAVORITE_AJAX_URL.replace(PRODUCT_CODE_TOKEN, productCode), function (result) {
        if (result.success) {
            $button.addClass(ACTIVE_CLASS);

            var $favCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(FAVORITES_COUNT_SELECTOR);
            $favCount.text(Number($favCount.text()) + 1);
            $favCount.prev().find('.u-screen-reader').text("Favorites " + $favCount.text() + " items.");

            sendFillToScreenReader($button);
            snapChatAddToWishList(productCode);
        } else {
            resetFavoritedButton($heartOutline, $heartFill);
            $button.next(NOTIFICATION_SELECTOR).text("Error occurred trying to " + $button.data(FAVORITE_MESSAGE));
        }
    });
}

function unfavoriteProduct($button, productCode) {
    var $heartOutline = $button.find(OUTLINE_SELECTOR);
    var $heartFill = $button.find(FILL_SELECTOR);

    if (onFavoritesPage()) {
        $button.closest("li").fadeOut();
    }

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(UNFAVORITE_AJAX_URL.replace(PRODUCT_CODE_TOKEN, productCode), function (result) {
        if (result.success) {
            $button.removeClass(ACTIVE_CLASS);

            var $favCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(FAVORITES_COUNT_SELECTOR);
            var count = Number($favCount.text());
            if (count > 0) {
                $favCount.text(--count);
                $favCount.prev().find('.u-screen-reader').text("Favorites " + count + " items.");
            }

            if (onFavoritesPage()) {
                if (count === 0) {
                    window.location.reload();
                } else {
                    window.refreshPLP();
                }
            }

            sendUnfillToScreenReader($button);
        } else {
            $heartOutline.addClass('u-hide');
            $heartFill.removeClass('u-hide').addClass(ANIMATION_CLASS);
            $button.next(NOTIFICATION_SELECTOR).text("Error occurred trying to " + $button.data(UNFAVORITE_MESSAGE));
        }
    });
}

function initFavorites() {
    if (!onFavoritesPage() || window.rcProps.favoritesCount > 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("click", FAV_BUTTON_SELECTOR, function (e) {
            var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
            var productCode = $this.data("code");

            if (window.rcProps.isGuest && !window.rcProps.canGuestsHaveFavorites) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(MODAL_SELECTOR).data("codes", productCode);
                openModal();
            } else if ($this.hasClass(ACTIVE_CLASS)) {
                unfavoriteProduct($this, productCode);
            } else {
                favoriteProduct($this, productCode);
            }

            e.preventDefault();
        });
    }

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(MODAL_SELECTOR + " button").on("click", function () {
        var queryChar = /\?/.test(window.rcProps.signInHref) ? "&" : "?";
        window.location.href = window.rcProps.signInHref + queryChar + "favCodes=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(MODAL_SELECTOR).data("codes"));
    });
}

function sendFillToScreenReader($button) {
    $button.next(NOTIFICATION_SELECTOR).text($button.data(FAVORITE_NOTIFICATION));
    $button.find(SCREEN_READER_SELECTOR).text($button.data(UNFAVORITE_MESSAGE));
}

function sendUnfillToScreenReader($button) {
    $button.next(NOTIFICATION_SELECTOR).text($button.data(UNFAVORITE_NOTIFICATION));
    $button.find(SCREEN_READER_SELECTOR).text($button.data(FAVORITE_MESSAGE));
}

function openModal() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        open: "heart-feature-sync",
        triggerOpen: true,
        onClose: function onClose() {
            if (window.rcProps.favoritesCount === 0) {
                resetFavoritedButton(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(OUTLINE_SELECTOR), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(FILL_SELECTOR));
            }
        }
    });
}

/***/ })

/******/ });


// WEBPACK FOOTER //
// dist/favorites.js